import { get } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Card } from "semantic-ui-react";

import ResourceIcon from "../../resources/resourceIcon/ResourceIcon.jsx";
import ResourceMarker from "../../marking/ResourceMarker.jsx";
import LinkWithReset from "../../utils/LinkWithReset.jsx";
import ExpiryString from "../../utils/ExpiryString.jsx";

import { MODES } from "./modes.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";
import { AT_TYPES } from "../../../constants/entity.js";

class InviteCard extends Component {
  static propTypes = {
    invite: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired
  };

  static defaultProps = {
    mode: MODES.INVITEE
  };

  state = {
    isInvitee: false
  };

  static getDerivedStateFromProps(props, prevProps) {
    if (props !== prevProps) {
      const { invite, user } = props;

      // casting toLowerCase as sherpa will store user data as entered, though won't allow case insensitive duplicates.
      const isInvitee =
        get(invite, "subject.email", "").toLowerCase() ===
        get(user, "email", "").toLowerCase();

      return { isInvitee };
    }
  }

  // -- RENDER -- //

  renderGreeting = () => {
    const { invite, copy } = this.props;
    const { isInvitee } = this.state;

    // if the current user is the invitee
    if (isInvitee) {
      return <p>{copy("invite.invitee_greeting")}</p>;
    }

    const inviteEmail = get(invite, "subject.email", null);
    return (
      <p>
        <em>{inviteEmail}</em>
        {` ${copy("invite.inviter_greeting")}`}
      </p>
    );
  };

  render = () => {
    const { invite, copy } = this.props;

    return (
      <Card fluid as={LinkWithReset} to={invite["@id"]} className="invite-card">
        <Card.Content>
          <ExpiryString
            className="float-left"
            color="grey"
            size="small"
            style={{
              marginBottom: "0em",
              lineHeight: "2em",
              fontWeight: "normal"
            }}
            invite={invite}
            copy={copy("expiry_string")}
          />
          <ResourceMarker
            marking={invite.marking}
            type={AT_TYPES.INVITE}
            className="float-right"
            size="massive"
          />
        </Card.Content>

        <Card.Content>
          {this.renderGreeting()}
          <p>
            <ResourceIcon size="big" disabled={true} data={invite.object} />
          </p>
        </Card.Content>
      </Card>
    );
  };
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(InviteCard);
